<div id="openExtendsServiceHotelList" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title f-s-16 bold" style="color: black;">Config. Servicios Hotel</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="content__boxTble">
              <div class="table-responsive">
                <table class="table table-hover mb-0">
                  <thead class="thead-default">
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngIf="items.length == 0">
                      <td colspan="2"><span>No se encontraron registros</span></td>
                    </ng-container>
                    <ng-container *ngIf="items.length > 0">
                      <tr
                        *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                        <td>-</td>
                        <td>{{item.description}}</td>
                        <td class="text-center">
                          <a class="btn p-5 pointer text-danger bold" (click)="delete(item, i)">
                            <i class="far fa-trash-alt"></i>
                          </a>
                          <!-- <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                            <i class="fas fa-pencil-alt"></i>
                          </a> -->
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="col-md-12 ">
              <div class="row content_pagination">
                <div class="col-lg-4">
                  <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.
                  </p>
                </div>
                <div class="text-right col-lg-8">
                  <ng-container *ngIf="items.length > 0">
                    <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal"
          (click)="close()">Cerrar ventana</button>
      </div>
    </div>
  </div>
</div>
